var map = {
	"./American-Italian.svg": "95fc",
	"./American.svg": "c095",
	"./Argentine-Italian.svg": "7e4b",
	"./Argentine.svg": "e917",
	"./Australian.svg": "96e6",
	"./Austrian.svg": "163f",
	"./Belgian.svg": "2c08",
	"./Brazilian.svg": "4e38",
	"./British.svg": "0e86",
	"./Canadian.svg": "324f",
	"./Chilean.svg": "0de7",
	"./China.svg": "ff35",
	"./Colombian.svg": "1440",
	"./Czech.svg": "bc18",
	"./Danish.svg": "9b3d",
	"./Dutch.svg": "96f1",
	"./East German.svg": "aff3",
	"./Finnish.svg": "8154",
	"./French.svg": "68f9",
	"./German.svg": "6ca1",
	"./Hong Kong.svg": "82b2",
	"./Hungarian.svg": "7a4c",
	"./Indian.svg": "6967",
	"./Indonesian.svg": "ef45",
	"./Irish.svg": "bce8",
	"./Italian.svg": "e55e",
	"./Japanese.svg": "b539",
	"./Liechtensteiner.svg": "7fce",
	"./Malaysian.svg": "f000",
	"./Mexican.svg": "656d",
	"./Monegasque.svg": "2200",
	"./New Zealander.svg": "630d",
	"./Polish.svg": "f923",
	"./Portuguese.svg": "9200",
	"./Rhodesian.svg": "b843",
	"./Russian.svg": "758e",
	"./South African.svg": "03de",
	"./Spanish.svg": "4c95",
	"./Swedish.svg": "033e",
	"./Swiss.svg": "c4e5",
	"./Thai.svg": "b716",
	"./Uruguayan.svg": "2c01",
	"./Venezuelan.svg": "fe1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3d11";